import { createApp, nextTick } from 'vue';
import { Modal } from 'mdb-ui-kit';

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

import utils from '@js/modules/utils/utils';

let info_modal;

const app = createApp({
    data: () => {
        return {
            info: null,
        };
    },
    methods: {
        showInfoModal(info) {
            this.info = info;
            this.info.text = utils.nl2br(info.text);
            if (!info_modal) {
                const mdl = document.getElementById('info_modal');
                info_modal = new Modal(mdl);
            }
            info_modal.show();
        },
    },
});

app.mount('#app');

const lightbox = new PhotoSwipeLightbox({
    // may select multiple "galleries"
    gallery: '#gallery--getting-started',
    // Elements within gallery (slides)
    children: 'a',
    // setup PhotoSwipe Core dynamic import
    pswpModule: PhotoSwipe,
});
lightbox.init();
